<!--
Copyright 2025 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<crucible-dialog
  [dialogTitle]="title"
  [form]="form"
  submitLabel="Save"
  [submitDisabled]="!form.valid || !form.dirty"
  [guardUnsavedWork]="true"
  (submit)="onClick()"
>
  <div crucibleDialogContent [formGroup]="form" class="name-form">
    @if (message) {
      <p>{{ message }}</p>
    }

    <mat-form-field class="form-full-width">
      <mat-label>Name</mat-label>
      <input
        formControlName="name"
        matInput
        placeholder="Name"
        autocomplete="off"
        cdkFocusInitial
        />

      @if (name.invalid && (name.dirty || name.touched)) {
        <mat-error>
          @for (validator of validators; track validator) {
            @if (name.hasError(validator.name)) {
              {{ validator.errorMessage }}<br />
            }
          }
        </mat-error>
      }
    </mat-form-field>
  </div>
</crucible-dialog>
